import React, { Fragment } from 'react';
import classNames from 'classnames';

export default function Label(props) {

    const {
        label,
        name,
        required,
        color,
        fieldId,
        focused,
        relative
    } = props;

    const LabelContainerClasses = classNames({
        "flex items-center h-5 bg-white px-1 left-4 pointer-events-none transition-all duration-200": true,
        "absolute z-1": !relative,
        "top-9": !focused && !relative,
        "top-3": focused && !relative,
    })

    const LabelClasses = classNames({
        "text-sm leading-none": true,
        "text-gray": !color,
        [`text-${color}`]: color,
    })

    if (!label) {
        return <Fragment></Fragment>
    }

    return (
        <div className={LabelContainerClasses}>
            <label htmlFor={fieldId || name} className={LabelClasses}>
                {label ? label : ''} {required ? ' *' : ''}
            </label>
        </div>
        
    )
}
